export const convertRules = (rules) => {
    var _a;
    if (!rules) {
        return rules;
    }
    const required = (_a = rules.find((rule) => {
        return rule.required !== undefined;
    })) === null || _a === void 0 ? void 0 : _a.required;
    const validations = {};
    const validationErrors = {};
    rules.map((rule) => {
        Object.keys(rule).map((ruleName) => {
            if (ruleName !== 'message' && ruleName !== 'required') {
                validations[ruleName] = rule[ruleName];
            }
            if (rule.message && ruleName !== 'message') {
                validationErrors[ruleName] = rule.message;
            }
        });
    });
    return { required, validations, validationErrors };
};
